"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.QnADropDown = void 0;
const react_1 = __importDefault(require("react"));
const common_1 = require("../../../../common");
const Colors_1 = require("../../../../Colors");
const GlobalStateProvider_1 = require("../../../../GlobalStateProvider");
exports.QnADropDown = react_1.default.memo(({ buttonTitle, icon, isOpen, handlerOnClick, }) => {
    const { isMobile } = (0, GlobalStateProvider_1.useGlobalState)();
    return (react_1.default.createElement(common_1.Button, { key: "renderQuestionList", className: `${icon === 'question' ? 'btn_line_dark_tur' : 'btn_line_pink'} mobile-full`, text: buttonTitle, option: {
            buttonBeforeIcon: {
                show: true,
                name: icon,
                size: 18,
                color: `${icon === 'question'
                    ? isMobile
                        ? Colors_1.Colors.dark_tur
                        : Colors_1.Colors.tur
                    : Colors_1.Colors.pink}`,
            },
            buttonAfterIcon: {
                show: true,
                name: 'arrow',
                className: isOpen ? 'arrow-up' : 'arrow-down',
                size: 25,
                color: `${icon === 'question' ? Colors_1.Colors.dark_tur : Colors_1.Colors.pink}`,
            },
        }, styles: {
            buttonWrap: {
                background: `${icon === 'question' ? '#f8fcfc' : '#fffdfe'}`,
            },
        }, onClick: () => handlerOnClick(icon) }));
});
